import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/components/stepper.scss';

class Stepper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { steps, activeStep, language, mode, style } = this.props;
    return (
      <React.Fragment>
        {mode === 'normal' &&
          <section className="stepper__container" style={style}>
            <div className="stepper__header">
              {steps.map((s, index) =>
                <div key={s.id} className={classnames("step__item", activeStep >= index && 'step__item--active')}>
                  {index > 0 && <div className="step__connector">
                    <span></span>
                  </div>}
                  <div className="step__label">
                    <span>{index + 1}</span>
                    <label>{language[s.label]}</label>
                  </div>
                </div>
              )}
            </div>
          </section>
        }
        {mode === 'time' &&
          <section className="time-stepper-container" style={style}>
            <div className="stepper__header">
              {steps.map((s, index) =>
                <div key={s.id} className={classnames("step__item", activeStep >= index && 'step__item--active')}>
                  {index > 0 && <div className="step__connector">
                    <span></span>
                  </div>}
                  <div className="step__label">
                    <label>{language[s.label]}</label>
                    <span></span>
                    <label>{s.time}</label>
                  </div>
                </div>
              )}
            </div>
          </section>
        }
      </React.Fragment>
    )
  }
}

Stepper.defaultProps = {
  steps: [],
  activeStep: 0,
  mode: 'normal',
  style: {}
}

export default connect(
  state => ({
    language: state.app.language
  })
)(Stepper)
